export default class RoamTool {
  private keyFrameList: RoamKeyFrame[] = [];

  constructor(
    private mapInstance: LooseObject,
    public originalData: RoamKeyFrame[] = [],
    public loop: number,
    public duration: number,
  ) {
    this.mapInstance = mapInstance;
    this.originalData = originalData;
    this.loop = loop;
    this.duration = duration;
    this.formatData();
    return this;
  }

  public start() {
    this.mapInstance.startAnimation(this.keyFrameList, {
      duration: this.duration * 1000,
      loop: this.loop,
    });
    return this;
  }

  public stop() {
    this.mapInstance?.stopAnimation();
    return this;
  }

  public setData(data: RoamKeyFrame[]) {
    this.stop();
    this.originalData = data;
    this.formatData();
    return this;
  }

  public setLoop(val: number) {
    this.stop();
    this.loop = val;
    return this;
  }

  public setDuration(val: number) {
    this.stop();
    this.duration = val;
    return this;
  }

  public destroy() {
    this.stop();
    this.originalData = [];
    this.keyFrameList = [];
  }

  protected formatData() {
    this.keyFrameList = this.originalData.map((data: RoamKeyFrame) => {
      const { type = 'MAP' } = data;
      const keyFrame = { ...data };
      if (type === 'CAMERA') {
        keyFrame.position = new TMap.LatLng(data.center.lat, data.center.lng, data.center.height || 0);
      } else {
        keyFrame.center = new TMap.LatLng(data.center.lat, data.center.lng, data.center.height || 0);
      }
      return keyFrame;
    });
  }
}

